var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(value,index){return _c('div',{key:index,staticClass:"first-text"},[_vm._v(" "+_vm._s(value)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }